import { Http } from '@/lib/http';
export class SourceOfWealthService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/source-of-wealth/';
  }
  getSourceOfWealth() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  createSourceOfWealth(source) {
    return this.httpClient().post(`${this.endpoint}`, source);
  }
  updateSourceOfWealth(id, source) {
    return this.httpClient().patch(`${this.endpoint}${id}`, source);
  }
  deleteSourceOfWealth(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
